module.exports = __webpack_public_path__ + "img/1765770688700-Screenshot 53.png.e06cc576.webp";